export default {
	
	validations: {
		required: "El valor es requerido.",
		undefined: "El valor es requerido.",
		email: "El valor no es una dirección de correo electrónico válida",
		minLength: "Este campo debe tener al menos ${min} caracteres",
		maxLength: "La longitud máxima permitida es ${max}",
		minValue: "El valor mínimo permitido es ${min}",
		maxValue: "El valor máximo permitido es ${max}",
		numeric: "El valor debe ser numérico",
		ipAddress: "El valor no es una dirección IP válida",
		sameAs: "El valor debe ser igual al valor de ${otherName}",
	}
}